module.exports = __webpack_public_path__ + "static/img/our-customers-building-marriott.a471ab1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-building-marriott.jpg
// module id = 7uz2
// module chunks = 0